import { merge } from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box, TextField, Autocomplete, CircularProgress, FormControl, InputLabel, Select, MenuItem, IconButton, Pagination, Skeleton } from '@material-ui/core';
//
import { BaseOptionChart } from '../../charts';
import { empty } from 'src/Helpers/Common';
import  axios  from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import moment from 'moment';

// ----------------------------------------------------------------------

// Skeleton component that mimics the vertical bar chart design
const ChartSkeleton = () => {
  const skeletonCount = 20; // Match the itemsPerPage
  
  return (
    <Box sx={{ mt: 3, mx: 3 }} dir="ltr">
      {/* Chart skeleton container */}
      <Box sx={{ height: 364, position: 'relative', display: 'flex', alignItems: 'end', justifyContent: 'space-between', px: 2, pl: 4 }}>
        {/* Y-axis label skeleton */}
        <Box sx={{ position: 'absolute', left: -20, top: '50%', transform: 'rotate(-90deg)' }}>
          <Skeleton variant="text" width={60} height={16} />
        </Box>
        
        {/* Vertical bars skeleton */}
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '4%' }}>
            {/* Red expense bar */}
            <Skeleton 
              variant="rectangular" 
              width="100%" 
              height={`${Math.random() * 200 + 50}px`} 
              sx={{ 
                borderRadius: '4px 4px 0 0',
                backgroundColor: 'rgba(255, 72, 66, 0.4)',
                mb: 0.5
              }} 
            />
            
            {/* Blue budget bar */}
            <Skeleton 
              variant="rectangular" 
              width="100%" 
              height={`${Math.random() * 100 + 20}px`} 
              sx={{ 
                borderRadius: '4px 4px 0 0',
                backgroundColor: 'rgba(28, 202, 255, 0.4)',
                mb: 1
              }} 
            />
            
            {/* Job name skeleton */}
            <Skeleton 
              variant="text" 
              width="100%" 
              height={12} 
              sx={{ fontSize: '10px' }}
            />
          </Box>
        ))}
      </Box>
      
      {/* X-axis label skeleton */}
      <Box sx={{ mt: 2, mb: 2, display: 'flex', justifyContent: 'center' }}>
        <Skeleton variant="text" width={40} height={16} />
      </Box>
    </Box>
  );
};

// Legend skeleton component
const LegendSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 3, mt: 1, mr: 3, mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ width: 12, height: 12, backgroundColor: 'rgba(255, 72, 66, 0.4)', borderRadius: '50%' }} />
        <Skeleton variant="text" width={60} height={14} />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ width: 12, height: 12, backgroundColor: 'rgba(28, 202, 255, 0.4)', borderRadius: '50%' }} />
        <Skeleton variant="text" width={60} height={14} />
      </Box>
    </Box>
  );
};

const  EcommerceYearlySales = React.memo(() => {
 const  navigate = useNavigate()
  const [projects,setProjects] = useState([])
  const [allProjects,setAllProjects]= useState([])
  const [loading, setLoading] = useState(true);
  const [selectedPhase, setSelectedPhase] = useState('4');
  const [isEnlarge,setIsEnlarge] = useState(false)
  const user = localStorage.getItem('user')
  const userData = JSON.parse(user)
  let userType = userData?.user_type;
  let userId = userData?.user_id;
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 20;

  if(userData.added_by_client && userData.parent_user_type && userData.parent_id) {
    userId = userData.parent_id
    userType =userData.parent_user_type
  }
  
  console.log('allProjects====',allProjects)
  useEffect(()=>{
    fetchAllProjects()
  },[userType])

  const handleProjectByname=(value)=>{
    if(!empty(value)){
    setProjects([value])
    }else{
      setProjects(allProjects)
    }
    setCurrentPage(0);
  }

const fetchAllProjects = async(selectedPhaseValue='4', page=0)=>{
  try {
    setLoading(true)
    let all=false
    if(selectedPhaseValue=="4"){
      all=true;
    }
    
    // NEW OPTIMIZED API - faster and returns only essential data with pagination
    const res = await axios.post(REST_API_END_POINT+'settings/project-statistics-optimized',
      { all, selectedPhaseValue, userType, userId, page, limit: 20 })
      let data = res?.data?.data || []
      let totalCount = res?.data?.totalCount || 0
    
    setProjects(data)
    setAllProjects(data)
    setTotalCount(totalCount)
    setCurrentPage(page);
    
    // BACKUP - OLD API (commented out for reference)
    // const res = await axios.post(REST_API_END_POINT+'settings/project-statistics',
    //   { all, selectedPhaseValue, userType, userId })
    //   let data = res?.data?.data || []
    // setProjects(data)
    // setAllProjects(data)
    // setCurrentPage(0);
    
  } catch (error) {
    console.log(error)
  } finally {
    setLoading(false)
  }
  
}
const handlePhaseChange = (event) => {
  setSelectedPhase(event.target.value);
  fetchAllProjects(event.target.value)
  
};

// Pagination is now handled by backend - no need to slice data
const paginatedProjects = projects;
const totalPages = Math.ceil(totalCount / itemsPerPage);

const handleBarFocus = (event, chartContext, config) => {
  const clickedProject = paginatedProjects[config.dataPointIndex];
  if (clickedProject) {
    setIsEnlarge(true)
    setProjects([clickedProject]);
    setCurrentPage(0);
  }
  
};

const handleBarNavigate = (event, chartContext, config) => {
  const clickedProject = paginatedProjects[config.dataPointIndex];
  setIsEnlarge(false)
  if (clickedProject) {
    navigate(PATH_DASHBOARD.project.viewproject + clickedProject.id,{state:{fromDashboard:true}}); 
  }
  setProjects(allProjects);
  setCurrentPage(0);
};


  const chartOptions = merge(BaseOptionChart(), {
    legend: { position: 'top', horizontalAlign: 'right' }, 
      colors: ['#FF4842', '#1CCAFF'], 
    // legend:{show: false},
    xaxis: {
      // categories:paginatedProjects?.map(project => project?.name),
      categories: paginatedProjects?.map(project => {
        const name = project?.name || '';
        return isEnlarge ? name : (name.length > 15 ? name.slice(0, 15) + '...' : name);
      }),
      title:{
        text:'JOBS',
        style: {
          color: '#ffffff'
        },
       },
    },
    yaxis:{
      title:{
        text:'COST ($)',
        style: {
          color: '#ffffff'
        },
       },
       
    },
    chart: {
      events: {
        dataPointSelection:  isEnlarge ? handleBarNavigate : handleBarFocus,
      },
    },
    tooltip: {
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        const project = paginatedProjects[dataPointIndex];
        if (!project) return '';
        
        // seriesIndex 0 = Expense (red), seriesIndex 1 = Budget (blue)
        if (seriesIndex === 0) {
          // Simple tooltip for Expense (red bars)
          return `
            <div style="background: #2a2a2a; padding: 8px; border-radius: 4px; color: #ffffff; font-size: 12px;">
              <div style="display: flex; align-items: center;">
                <div style="width: 8px; height: 8px; background-color: #FF4842; border-radius: 50%; margin-right: 6px;"></div>
                <span>Expense: $${project.expense?.toFixed(2) || '0.00'}</span>
              </div>
            </div>
          `;
        } else {
          // Detailed tooltip for Budget (blue bars)
          const formatDate = (timestamp) => {
            if (!timestamp) return 'N/A';
            return moment.unix(timestamp).format('MM/DD/YYYY');
          };
          
          return `
            <div style="background: #2a2a2a; padding: 12px; border-radius: 6px; color: #ffffff; font-size: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.3);">
              <div style="margin-bottom: 8px; font-weight: bold; color: #1CCAFF; font-size: 13px;"><strong>Job Name:</strong> ${project.name || 'N/A'}</div>
              <div style="margin-bottom: 4px;"><strong>Client:</strong> ${project.customer_name || 'N/A'}</div>
              <div style="margin-bottom: 4px;"><strong>Project:</strong> ${project.community_name || 'N/A'}</div>
              <div style="margin-bottom: 4px;"><strong>QB:</strong> ${project.doc_number || 'N/A'}</div>
              <div style="margin-bottom: 4px;"><strong>Due Date:</strong> ${formatDate(project.due_date)}</div>
              <div style="margin-bottom: 4px;"><strong>Budget:</strong> $${project.budget?.toFixed(2) || '0.00'}</div>
              <div style="margin-bottom: 0px;"><strong>Actual:</strong> $${project.expense?.toFixed(2) || '0.00'}</div>
            </div>
          `;
        }
      }
    },
  });

  const series = [
    {
      name: 'Expense',
      data: paginatedProjects?.map(project => project?.expense?.toFixed(2)),
    },
    {
      name: 'Budget',
      data: paginatedProjects?.map(project => project?.budget?.toFixed(2)),
    },
  ];
  return (
    <Card>
      <CardHeader
        title="Financial Analysis"
        
        action={
          <Fragment>
          <FormControl variant="outlined"  sx={{ width: 280,marginBottom:2 }}>
            <InputLabel id="phase-select-label">Phase</InputLabel>
            <Select
              labelId="phase-select-label"
              id="phase-select"
              value={selectedPhase}
              onChange={handlePhaseChange}
              label="Phase"
            >
              <MenuItem value="4">All</MenuItem>
              <MenuItem value="1">Pre production</MenuItem>
              <MenuItem value="2">Production</MenuItem>
              <MenuItem value="3">Post production & Installation</MenuItem>
              <MenuItem value="5">Completed</MenuItem>
              {/* Add more phases as needed */}
            </Select>
          </FormControl>
          <Autocomplete
            sx={{ width: 280 }}
            id="combo-box-demo"
            options={allProjects}
            loading={loading}
            onChange={(event, newValue) => {
              handleProjectByname(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Jobs"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            )}
            getOptionLabel={(option) => option.name}
          />
        </Fragment>
         
        }
      />
      
      {/* Legend skeleton - positioned below Jobs autocomplete */}
      {loading && <LegendSkeleton />}
      
        <Box  sx={{ mt: 3, mx: 3 }} dir="ltr"> 
          {loading ? (
            <ChartSkeleton />
          ) : (
            <ReactApexChart type="bar" series={series} options={chartOptions} height={364} />
          )}
        </Box>
        {totalPages > 1 && (
          <Box display="flex" justifyContent="flex-end" alignItems="center" sx={{ mx: 3,pb:2 }}>
            <Pagination
              count={totalPages}
              page={currentPage + 1}
              onChange={(event, value) => {
                const newPage = value - 1;
                fetchAllProjects(selectedPhase, newPage);
              }}
              color="primary"
              size="small"
            />
          </Box>
        )}
    </Card>
  );
});

export default EcommerceYearlySales;